export default __webpack_public_path__ + "static/media/email-veri-icon.7e40fae1.svg";